
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('g',{attrs:{"data-name":"Gruppe 27720"}},[_c('g',{attrs:{"data-name":"Gruppe 27719"}},[_c('g',{attrs:{"data-name":"Gruppe 27718"}},[_c('path',{attrs:{"d":"M16.276 19.015a6.087 6.087 0 01-2.618-.665 18.923 18.923 0 01-2.409-1.449l-.028-.021a35.123 35.123 0 01-4.247-3.838c-1.758-1.935-2.687-3.695-2.762-5.231a1.156 1.156 0 01.036-.332 3.96 3.96 0 013.105-2.476 2.032 2.032 0 01.578.054l.034.014.188.11a15.777 15.777 0 011.046 1.317c.417.569.941 1.318 1.105 1.614.379.684-.131 1.638-.469 2.269-.075.14-.1.195-.089.228a18.693 18.693 0 001.762 1.677c.2.184.4.368.587.543.468.439 1 .936 1.176.938a2.955 2.955 0 00.654-.334 2.7 2.7 0 011.324-.542l.075.017a15.825 15.825 0 012.5 1.272c.82.512 1.282.939 1.373 1.269l.016.09a4.063 4.063 0 01-.89 2.084 2.967 2.967 0 01-1.822 1.388 5.764 5.764 0 01-.225.004zM5.167 7.768c.063 1.305.91 2.863 2.514 4.63a34.435 34.435 0 004.122 3.724 17.817 17.817 0 002.265 1.366 4.921 4.921 0 002.384.57c.188-.009.6-.322 1.1-1a3.8 3.8 0 00.7-1.381 4.319 4.319 0 00-.937-.683 15.861 15.861 0 00-2.229-1.154 4.59 4.59 0 00-1.1.605 2.743 2.743 0 01-.564.324l-.1.019h-.016c-.423 0-1.974-1.368-2.442-1.789a15.2 15.2 0 01-2.109-2.188c-.1-.258.046-.531.231-.875.2-.367.605-1.129.478-1.36s-.56-.858-1.041-1.513c-.366-.5-.674-.9-.854-1.1a1.124 1.124 0 00-.175 0 2.528 2.528 0 00-1.418.681 2.591 2.591 0 00-.805 1.069.258.258 0 00-.004.055z","data-name":"Pfad 14192","fill":"#1b5be9","stroke":"#1b5be9","stroke-width":".4"}})])])])])
          )
        }
      }
    